<div class="rounded-border w-full border border-gray-300 bg-white p-4">
  <span class="text-gray-700">{{ message }}</span>
</div>
